import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=143782de&scoped=true&"
import script from "./MessageComponent.vue?vue&type=script&lang=js&"
export * from "./MessageComponent.vue?vue&type=script&lang=js&"
import style0 from "./MessageComponent.vue?vue&type=style&index=0&id=143782de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143782de",
  null
  
)

export default component.exports